<template>
  <div class="vue-template">
    <div class="jumbotron bg-gradient">
      <div class="container">
        <span
          class="d-flex align-items-center mb-5
             "
          onclick="
            window.history.go(-1);
            return false;
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            fill="currentColor"
            class="icon-20"
          >
            <path
              d="M 10.8125 9.28125 L 4.09375 16 L 10.8125 22.71875 L 12.21875 21.28125 L 7.9375 17 L 28 17 L 28 15 L 7.9375 15 L 12.21875 10.71875 Z"
              fill="currentColor"
            />
          </svg>
          Zurück</span
        >
        <h1 class="display-4" v-if="user.profileData.name">
          {{ user.profileData.name }}
        </h1>
        <p class="lead" v-if="user.profileData">
          {{ user.profileData.email }}
        </p>
      </div>
    </div>
    <div class="container">
      <h2>Books from {{ user.profileData.name }}</h2>
      <div v-for="book in user.books" :key="book.id" class="list-item">
        <router-link class="w-100" :to="'/book/' + book.id"
          ><div>
            {{ book.title }}
          </div></router-link
        >
        <div class="btn btn-danger delete" @click="deleteBook(book.id)">
          x
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  data() {
    return {
      user: {
        id: this.$route.params.id,
        books: [],
        profileData: [],
      },
      loggedinUser: null,
    };
  },
  created() {
    firebase.auth().onAuthStateChanged(loggedinUser => {
      if (loggedinUser) {
        this.loggedinUser = loggedinUser;
      } else {
        this.loggedinUser = null;
        this.$router.push('/login');
      }
    });

    firebase
      .firestore()
      .collection('users')
      .doc(this.$route.params.id)
      .get()
      .then(doc => {
        if (doc.exists) {
          this.user.id = doc.id;
          this.user.profileData = doc.data();
        } else {
          alert('No such document!');
        }
      });
    this.readBooks();
  },
  methods: {
    getUserDetails() {
      firebase
        .firestore()
        .collection('users')
        .doc(this.$route.params.id)
        .onSnapshot(function(doc) {
          // console.log(doc.data());
          this.user.profileData = doc.data();
        });
    },
    deleteBook(id) {
      let vm = this;
      firebase
        .firestore()
        .collection('books')
        .doc(id)
        .delete()
        .then(function() {
          // console.log('Document successfully deleted!');
          vm.user.books = [];
          vm.readBooks();
        })
        .catch(function(error) {
          return error;
          // console.error('Error removing document: ', error);
        });
    },
    readBooks() {
      if (firebase.auth().currentUser) {
        firebase
          .firestore()
          .collection('books')
          .where('owner', '==', this.user.id)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              this.user.books.push({
                id: doc.id,
                title: doc.data().title,
                author: doc.data().author,
                description: doc.data().description,
                isBorrowed: doc.data().isBorrowed,
                isBorrowedTo: doc.data().isBorrowedTo,
              });
            });
          })
          .catch(error => {
            return error;
            // console.log('Error getting documents: ', error);
          });
      }
    },
  },
};
</script>
